import { render, staticRenderFns } from "./UnifiedSearchInput.vue?vue&type=template&id=d454a7f4&scoped=true"
import script from "./UnifiedSearchInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./UnifiedSearchInput.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UnifiedSearchInput.vue?vue&type=style&index=0&id=d454a7f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d454a7f4",
  null
  
)

export default component.exports